<template>
  <el-dialog
          :title="'批量导入'"
          :close-on-click-modal="false"
          :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="80px" style="text-align: left">
      <el-form-item label="大队" prop="bmid" >
        <el-select :disabled="deptdisable"   filterable v-model="dataForm.bmid"  @change="selectChanged2"     placeholder="请选择大队">
          <el-option
                  v-for="item in depts"
                  :key="item.bmid"
                  :label="item.bmmc"
                  :value="item.bmid"
                  :disabled="deptdisable">
          </el-option>
        </el-select> 
        <el-select v-if="dataForm.type==1" :disabled="deptdisable"   filterable v-model="dataForm.childDeptId"     placeholder="请选择二队">
          <el-option
                  v-for="item in childDepts"
                  :key="item.bmid"
                  :label="item.bmmc"
                  :value="item.bmid"
                  >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="dataForm.type==1" label="岗位" prop="Gw" >
        <el-input style="width: 52%;" clearable placeholder="请输入岗位" v-model="dataForm.Gw"></el-input>
      </el-form-item>
      <el-form-item label="日期" prop="month">
        <el-date-picker
                v-model="dataForm.month"
                value-format="yyyy-MM"
                type="month"
                placeholder="选择月">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="类型">
        <el-radio-group v-model="dataForm.type">
          <el-radio :label="0">导入</el-radio>
          <el-radio :label="1">导出</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="dataForm.type==0" label="文件"  prop="file">
        <el-upload
                action="#"
                :limit="1"
                :file-list="imgList"
                :on-remove="handleRemove"
                :http-request="httpRequest"
                :before-upload="beforeAvatarUpload">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item v-else-if="dataForm.type==1" label="文件">
        <el-button type="primary"   @click="exportPb">导出排班表</el-button>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" v-if="dataForm.type==0" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { Loading } from 'element-ui';
  export default {
    data () {
      return {
        visible: false,
        dataForm: {
          Gw:'',
          childDeptId:'',
          bmid:'',
          month:'',
          file:'',
          filename:'',
          type:0
        },
        depts:[],
        childDepts:[],
        imgList:[],
        deptdisable:false,
        dataRule: {
          bmid: [
            {required: true, message: '部门不能为空', trigger: 'blur'}
          ],
          // Gw: [
          //   {required: true, message: '岗位不能为空', trigger: 'blur'}
          // ],
          month: [
            {required: true, message: '日期不能为空', trigger: 'blur'}
          ],
          file: [
            {required: true, message: '请上传文件', trigger: 'blur'}
          ]
        },
      }
    },
    methods: {
      selectChanged2(value) {
            this.currentPage =1
            this.childDepts = []
            this.childDept =''
            this.$request({
                method: 'get',
                url: '/bjba/kqtj/getMentForUser2',
                params: {
                    fbmid: value,
                    userid:this.$store.getters.username
                }
            }).then((response) => {
                this.childDepts = response.data;
                var zzdyqc = this.$store.getters.user.zzdyqc;
                if(zzdyqc){
                    if(zzdyqc != this.CONST_ZN_BM) {
                        var zw = this.$store.getters.user.zw;

                        if(zw) {
                            if(zw=='02'||zw=='03') {
                                if(this.childDepts[0]) {
                                    this.childDept = this.childDepts[0].bmid
                                }
                            }
                        }
                    }
                }
            }).catch((err) => {
                console.log(err)
            })
        },
      init () {
          this.visible = true
          this.dataForm.bmid = ''
          this.dataForm.childDeptId = ''
          this.$nextTick(() => {
            this.$refs['dataForm'].resetFields()
            this.imgList=[]
            this.getDepts()
          })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            let loadingInstance1 = Loading.service({ fullscreen: true });
            this.$http({
              url: `/bjba/pbgl/batchin/`,
              method: 'post',
              data: {
                'bmid': this.dataForm.bmid,
                'month': this.dataForm.month,
                'file': this.dataForm.file,
                'filename':this.dataForm.filename
              }
            }).then(({data}) => {
              loadingInstance1.close()
              if (data && data.code === 200) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500
                })
                this.visible = false
                this.$emit('refreshDataList')
              } else if(data && data.code === 500) {
                this.$message({
                  message: data.message,
                  type: 'error',
                  duration: 1500
                })
              }
            })
          }
        })
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
        this.dataForm.file=''
        this.dataForm.filename =''
      },
      beforeAvatarUpload(file){
        if(file.name.indexOf('.xls') >0 | file.name.indexOf('.xlsx')>0)
        return  true;
        else{
          this.$message.error('请上传excel文件')
          return  false
        }
      },
      exportPb() {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            var viewUrl = this.$request.defaults.baseURL+'/bjba/pbgl/exportExcelPb?bmid='+this.dataForm.bmid+'&date='+this.dataForm.month+'&childDept='+this.dataForm.childDeptId+'&GW='+this.dataForm.Gw+'&access_token='+this.$store.getters.token
            window.open(viewUrl)
          }
        })
      },
      httpRequest(data){
        let rd = new FileReader(); // 创建文件读取对象
        let file = data.file;
        this.dataForm.filename = data.file.name
        var that = this;
        rd.readAsDataURL(file); // 文件读取装换为base64类型
        rd.onloadend = function (e) {
          console.log(e)
          that.dataForm.file = e.currentTarget.result
        }
      },
      getDepts() {
        let that = this;
        this.$request.get('/bjba/kqtj/getFirstMentForUser',{
          params: {
            userid:this.$store.getters.username
          }
        }).then(res => {
          that.depts = res.data
          if(this.depts && this.depts[0]) {
            var zzdyqc = this.$store.getters.user.zzdyqc;
            if(this.CONST_MOSTHIGH_DEPTS&&this.CONST_MOSTHIGH_DEPTS.includes&&!this.CONST_MOSTHIGH_DEPTS.includes(zzdyqc)) {
              var zw = this.$store.getters.user.zw;
              if(zw) {
                if(zw=='01'||zw=='02'||zw=='03') {
                  this.dataForm.bmid = that.depts[0].bmid
                  this.deptdisable = true
                  if(zw !='01') {
                    // this.childdeptdisable =true;
                  }
                  // this.selectChanged2(this.form.dept)
                }
              } else {
                // this.selectChanged2(this.form.dept)
              }
            }
          }
        })
      }
    }
  }
</script>
